import * as yup from 'yup';

export const validationSchema = yup.object().shape({
  invoice: yup.string().required(),
});
